<button
  class="my-notification"
  [class.my-notification--important]="notification().important"
  [class]="['my-notification--' + notification().type.toLowerCase()]"
  (click)="openNotificationDialog()"
  portalDropdownItem
>
  <div class="my-notification__content">
    <div class="my-notification__name">
      <span class="text-wrap" [arrow]="false" [portalTippy]="title()" [showIfTruncated]="true">
        {{ title() }}
      </span>
      <span class="badge text-bg-primary ms-1 align-self-center">{{ 'common.new' | translate }}</span>
    </div>

    <span class="w-100 text-muted d-flex justify-content-between">
      <small>
        {{ notification().publishedAt | portalTimeAgo }}
      </small>
    </span>
  </div>

  <div class="my-notification__indicators">
    @if (notification().important) {
      <div class="my-notification-indicator--important"></div>
    }
  </div>
</button>
